export default "/images/overlay.png";